<template>
<dv-full-screen-container :style="resizeWarp">
    <div >
      <div class="resize" :style="scalebox">
        <div class="top">
          <!-- 最左logo文字 -->
          <div class="top-container">
            <span class="header-logo " @click="goBack()">
              <span class="logo-text float-left m-l-10">智慧建筑后台</span>
            </span>
          </div>
        <!-- 中间项目名称 -->
           <div class="prjName">
                <h1>{{prjName}}</h1> 
            </div>
            <!-- 最右时间 -->
          <div class="top-date">
            <span>{{date}}</span><br /><span>{{time}}</span>
          </div>
        </div>
        <header>
          <div class="header-left">
            <dv-decoration-2 style="width:33%;height:5px;" /><dv-decoration-8
              style="width:100%;height:50px;"
            />
          </div>
          <div class="header-center">
            <span>人员实名制</span>
          </div>
          <div class="header-right">
            <dv-decoration-2
              style="width:33%;height:5px;"
              class="header-line"
            /><dv-decoration-8
              :reverse="true"
              style="width:100%;height:50px;"
            />
          </div>
        </header>
        <div class="container">
          <el-row type="flex" class="w-h-100" :gutter="10">
              <el-col :span="20"  >
                <el-row type="flex" style="height:50%" :gutter="10">
                <!-- 人员项目概览 -->
                  <el-col :span='10'>
                    <div class="w-h-100">
                      <projectOverview :projectInfo='projectInfo'></projectOverview>
                    </div>
                  </el-col>
                  <!-- 视频播放 -->
                  <el-col :span='14'>
                    <div class="w-h-100">
                      <attendance ref='attendance'></attendance>
                      <!-- <statistics ref='statistics'></statistics> -->
                    </div>
                  </el-col>
                </el-row>
                <el-row type="flex" style="height:48%" :gutter="10">
                  <el-col :span='8' >
                    <div class="w-h-100 m-t-2-percent">
                      <approachCurve ref='approachCurve' ></approachCurve>
                    </div>
                  </el-col>
                  <el-col :span='8'>
                    <div class="w-h-100 m-t-2-percent">
                      <workType ref='workType'></workType>
                    </div>
                  </el-col>
                  <el-col :span='8'>
                    <div class="w-h-100 m-t-2-percent">
                      <personnelBePresent ref='personnelBePresent'></personnelBePresent>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col style="height:100%" :span="5">
                <div class="w-h-100">
                  <personnelAttendance ref='personnelAttendance'></personnelAttendance>
                </div>
              </el-col>
            </el-row>

        </div>
      </div>
    </div>
  </dv-full-screen-container>

  
</template>
<style lang="scss" scoped>

.flex{
  display: flex;
}
.w-h-100{
  width: 100%;
  height: 100%;
}
.m-t-2-percent{
  margin-top: 2%;
}
.bg {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  transition: 0.3s;
}
.resize {
  width: 1920px;
  height: 1080px;
  transform-origin: 0 0;
  transition: all 0.3s;
}
.header-logo {
  cursor: pointer;
  align-items: center;
  display: flex;
}
.header-logo img {
  width: 70px;
}
.logo-text {
  line-height: 60px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 35px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.top {
  width: 100%;
  height: auto;
  padding-top: 15px;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.prjName{
  color: transparent;
	-webkit-text-fill-color: #fff;//文字色
	font-weight: 700;
	-webkit-text-stroke: 3px rgba(115, 97, 97, 0.143);//边框色
  h1{
    text-overflow:ellipsis;
    white-space: nowrap;//禁止换行
    overflow: hidden;
    width: 100%;
  }
  width: 60%;
  font-size: 1.5rem;
  color: white;
  text-align: center;
  
}
.top-container {
  width: 20%;
  height: auto;
  display: flex;
  justify-content: space-around;
}
.top-date {
text-align: right;
  width: 20%;
  font-size: 27px;
  color: #cecdce;
}
header {
  width: 100%;
  height: auto;
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
header div {
  height: auto;
  color: #cecdce;
}
.header-left {
  width: 33%;
}
.header-center {
  text-align: center;
  width: 33%;
  font-size: 30px;
}
.effect {
  margin: 0 auto;
}
.header-right {
  width: 33%;
}
.header-right :not(p) {
  margin-left: auto;
}
.header-line {
  transform: rotateY(150deg);
  margin-right: -3%;
}
.container {
  width: 100%;
  height: calc(100% - 168px);
  margin-top: 10px;
}
</style>
<script>
import projectOverview from "../component/certification/projectOverview";
// import statistics from "../component/certification/statistics";
import attendance from "../component/certification/attendance";
import approachCurve from "../component/certification/approachCurve";
import workType from "../component/certification/workType";
import personnelAttendance from "../component/certification/personnelAttendance";
import personnelBePresent from "../component/certification/personnelBePresent";
import reconnectingWebsocket from 'reconnecting-websocket';
export default {
  components:{
    projectOverview,
    // statistics,
    attendance,
    approachCurve,
    workType,
    personnelAttendance,
    personnelBePresent,
  },
  data() {
    return {
      prjName:'',
      projectInfo:{},
      videoConfig:{},
      width: 1920,
      height: 1080,
      scalebox: {
        transform: "",
        marginLeft: null,
      },
      resizeWarp: {
        width: null,
        height: null,
      },
      scale: null,
      list: [],
      timer:null,
      time:'',
      date:''
      
    };
  },
  methods:{
      initWebSocket(){
        this.ws = new reconnectingWebsocket(this.api.BI.certification);
        let ws = this.ws;
        ws.onopen = res=>{
          this.load = this.loading();
          let prjCode  = sessionStorage.getItem("prjCode");
          let message = JSON.stringify({prjCode:prjCode});
          ws.send(message); //将消息发送到服务端
        }
        ws.onmessage = res=>{
          let data = JSON.parse(res.data);
          if(data.code == 0){
             data = data.data;
             //项目概览
            this.projectInfo = data.prjData
            this.projectInfo.memberCount = data.memberData.count;
             //考勤列表
            this.$refs.personnelAttendance.changeData(data.attendanceList);
             //曲线图-X轴公共参数
            let hourRange = data.attendanceCount.hourRange;
            //曲线图-七天进场统计
            this.$refs.approachCurve.changeData(data.weekAttendance.count,data.weekAttendance.days);
            //曲线图-人员在场
            this.$refs.personnelBePresent.changeData(data.attendanceCount.inCount,hourRange);
            //视频播放（取消）
            // this.$refs.statistics.init(data.videoData);

            this.$refs.attendance.changeData(data.attendanceList[0]);
            

            //现场工种
            this.$refs.workType.changeData(data.memberData.workType);
            this.load.close();
          }
        }
        ws.onerror = res=>{
          this.load = this.loading();
        }
      },
    goBack(){
      if(this.$router.go(-1) == undefined){
        $router.push({ name: 'modules' })
      }else{
        this.$router.go(-1)
      }
    },
    getScale() {
      const { width, height } = this;
      const wh = window.innerHeight / height;
      const ww = window.innerWidth / width;
      return ww < wh ? ww : wh;
    },
    getMargin() {
      const { width } = this;
      let margin = (window.innerWidth - 1920 * this.scale) / 2;
      return margin;
    },
    setScale() {
      this.scale = this.getScale();
      this.resizeWarp.width = window.innerWidth + "px";
      this.resizeWarp.height = window.innerHeight + "px";
      this.scalebox.transform = "scale(" + this.scale + ")";
      this.getMargin();
      this.scalebox.marginLeft = this.getMargin() + "px";
    },
    ser() {
      this.timer = setInterval(this.getTime, 1000);
    },
    getTime() {
      let date = new Date(),
        y = date.getFullYear()+'年',
        M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '月',
        D = date.getDate() + '日',
        h = (date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours())+':',
        m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+':',
        s = (date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds()),
        week=date.getDay(),
        weekStr = new Array("日","一", "二", "三", "四", "五", "六"),
        weekResult = '星期' + weekStr[week];
        this.date = y+M+D
        this.time = h+m+s+weekResult
    },
  },
  beforeDestroy(){
      clearInterval(this.timer)
    this.ws.close();
    this.load.close();
  },
  mounted(){
    this.setScale();
    window.addEventListener("resize", this.setScale);
    this.ser();
    
    if("WebSocket" in window){
      // this.load = this.loading();
      this.prjName = sessionStorage.getItem('projectName');
      this.initWebSocket();
    }
  }
};
</script>
